// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card-title[data-v-183d179f]{font-size:1.25rem;font-weight:700}.v-simple-table td[data-v-183d179f]{vertical-align:middle}.green-row[data-v-183d179f]{background-color:#cffede}", ""]);
// Exports
module.exports = exports;
